import { render } from "./bulk-action-modal.vue?vue&type=template&id=6cadec7c"
import script from "./bulk-action-modal.vue?vue&type=script&lang=js"
export * from "./bulk-action-modal.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__